import { GRADIENTS, GRADIENTS2, GRADIENTS3 } from '_constants/styles'

export const COLORS = [
  GRADIENTS.DS_BLUE_LIGHT.TO,
  GRADIENTS.DS_PINK_DARK.TO,
  GRADIENTS.DS_BLUE_DARK.TO,
  GRADIENTS.DS_YELLOW.TO,
  GRADIENTS.DS_BLACK.TO,
]

// option 1
// export const CHART_COLORS = [
//   {
//     to: GRADIENTS.DS_BLUE_LIGHT.TO,
//     from: GRADIENTS.DS_BLUE_LIGHT.FROM,
//   },
//   {
//     to: GRADIENTS.DS_PINK_DARK.TO,
//     from: GRADIENTS.DS_PINK_DARK.FROM,
//   },
//   {
//     to: GRADIENTS.DS_BLUE_DARK.TO,
//     from: GRADIENTS.DS_BLUE_DARK.FROM,
//   },
//   {
//     to: GRADIENTS.DS_YELLOW.TO,
//     from: GRADIENTS.DS_YELLOW.FROM,
//     text: 'black',
//   },
//   {
//     to: GRADIENTS.DS_BLACK.TO,
//     from: GRADIENTS.DS_BLACK.FROM,
//   },
//   {
//     to: GRADIENTS.DS_LIGHT_GREEN.TO,
//     from: GRADIENTS.DS_LIGHT_GREEN.FROM,
//   },
//   {
//     to: GRADIENTS.DS_BROWN.TO,
//     from: GRADIENTS.DS_BROWN.FROM,
//   },
//   {
//     to: GRADIENTS.DS_TEAL_GREEN.TO,
//     from: GRADIENTS.DS_TEAL_GREEN.FROM,
//   },
//   {
//     to: GRADIENTS.DS_RED.TO,
//     from: GRADIENTS.DS_RED.FROM,
//   },
//   {
//     to: GRADIENTS.DS_DARK_GREEN.TO,
//     from: GRADIENTS.DS_DARK_GREEN.FROM,
//   },
// ]

// option 2
// export const CHART_COLORS = [
//   {
//     to: GRADIENTS2.BLUE_DARK.TO,
//     from: GRADIENTS2.BLUE_DARK.FROM,
//   },
//   {
//     to: GRADIENTS2.PINK.TO,
//     from: GRADIENTS2.PINK.FROM,
//   },
//   {
//     to: GRADIENTS2.GREEN_LIGHT.TO,
//     from: GRADIENTS2.GREEN_LIGHT.FROM,
//     text: 'black',
//   },
//   {
//     to: GRADIENTS2.ORANGE.TO,
//     from: GRADIENTS2.ORANGE.FROM,
//     text: 'black',
//   },
//   {
//     to: GRADIENTS2.RED.TO,
//     from: GRADIENTS2.RED.FROM,
//   },
//   {
//     to: GRADIENTS2.BLUE_LIGHT.TO,
//     from: GRADIENTS2.BLUE_LIGHT.FROM,
//     text: 'black',
//   },
//   {
//     to: GRADIENTS2.PURPLE.TO,
//     from: GRADIENTS2.PURPLE.FROM,
//   },
//   {
//     to: GRADIENTS2.SALMON.TO,
//     from: GRADIENTS2.SALMON.FROM,
//     text: 'black',
//   },
//   {
//     to: GRADIENTS2.YELLOW.TO,
//     from: GRADIENTS2.YELLOW.FROM,
//     text: 'black',
//   },
//   {
//     to: GRADIENTS2.BLACK.TO,
//     from: GRADIENTS2.BLACK.FROM,
//   },
// ]

// option 3
export const CHART_COLORS = [
  {
    to: GRADIENTS3.BLUE_LIGHT.TO,
    from: GRADIENTS3.BLUE_LIGHT.FROM,
  },
  {
    to: GRADIENTS3.PINK.TO,
    from: GRADIENTS3.PINK.FROM,
  },
  {
    to: GRADIENTS3.PURPLE.TO,
    from: GRADIENTS3.PURPLE.FROM,
  },
  {
    to: GRADIENTS3.YELLOW.TO,
    from: GRADIENTS3.YELLOW.FROM,
    text: 'black',
  },
  {
    to: GRADIENTS3.BLACK.TO,
    from: GRADIENTS3.BLACK.FROM,
  },
  {
    to: GRADIENTS3.GREEN_DARK.TO,
    from: GRADIENTS3.GREEN_DARK.FROM,
  },
  {
    to: GRADIENTS3.GREEN_LIGHT.TO,
    from: GRADIENTS3.GREEN_LIGHT.FROM,
    text: 'black',
  },
  {
    to: GRADIENTS3.TEAL.TO,
    from: GRADIENTS3.TEAL.FROM,
  },
  {
    to: GRADIENTS3.BROWN.TO,
    from: GRADIENTS3.BROWN.FROM,
  },
  {
    to: GRADIENTS3.RED.TO,
    from: GRADIENTS3.RED.FROM,
  },
]
